// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SendBudget_sectionHeader__3BqL5","compoundSectionHeader":"SendBudget_compoundSectionHeader__1lV71","section":"SendBudget_section__2MZQN"};